












import Vue from 'vue';
import FacilityContactControl from "@/componentsReusable/FacilityContactControl.vue";
export default Vue.component('facility-contact-modal', {
  name: 'FacilityContactModal',
  props: {
    facilityContactId: {
      type: Number,
      required: false
    },
  },
  components: {
    FacilityContactControl
  },
  methods: {
    selectFacilityContact (facilityContact: any) {
      this.$emit('facilityContactSelected', facilityContact );
    },
    cancel (event: any) {
      if (event.target.className.indexOf('cancel-on-click') !== -1) {
        this.$emit('cancelEvent');
      }
    }
  }
});



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/componentsReusable/FacilityContactModal.vue